var Transport = require('./base');
var util = require('widgets-util');


function XhrError(message, status) {
  Error.call(this);

  this.name = 'XhrError';
  this.message = message;
  this.status = status;
}

util.inherits(XhrError, Error);

var XHR;
module.exports = XHR = function XHR(options) {
  Transport.call(this, options);
};

XHR.supported = function() {
  var xhr = new XMLHttpRequest();
  return 'withCredentials' in xhr;
};

util.inherits(XHR, Transport);

XHR.prototype.constructor = XHR;

XHR.prototype.send = function(options, callback) {
  var req = new XMLHttpRequest();

  if(Object.prototype.toString.call(options) == '[object String]') {
    options = { url: options };
  }

  req.open(options.method || 'GET', options.url, true);

  options.headers = options.headers || {};
  options.headers['X-Requested-With'] = 'XMLHttpRequest';

  req.withCredentials = true;

  util.forOwn(options.headers, function(value, key) {
    req.setRequestHeader(key, value);
  });

  req.onreadystatechange = function() {
    if(req.readyState != 4) return;

    if([
      200,
      304,
      0
    ].indexOf(req.status) === -1) {
      callback(new XhrError('Server responded with a status of ' + req.status, req.status));
    } else {
      callback(null, req.responseText);
    }
  };

  if(typeof console !== 'undefined' && console.log) {
    req.onerror = function() {
      console.log('We encountered an error attempting to fulfill the request. Please ensure that "' + location.protocol + '//' + location.host + '" is whitelisted in CORS list.');
    };
  }

  req.send(options.data || void 0);
};